import { KeyNames } from "./keys-names";
import { RanchFieldPriority, ranchFieldsProperties } from "./ranch";

let defaultPriority: RanchFieldPriority = 0;

let defaultEditableField = {
    telematic: null,
    manual: null,
    satelital: null,
    priority: defaultPriority,
    value: null
}

export const HarvestRanchAditionalFields = {
    ranking: defaultEditableField,
    sowing_start: defaultEditableField,
    resowing_start: defaultEditableField,
    harvested_area: defaultEditableField,
    resowing_area: defaultEditableField,
}